/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { rootGetApiV3Changelog } from "../../funcs/rootGetApiV3Changelog.js";
import { formatResult, ToolDefinition } from "../tools.js";

export const tool$rootGetApiV3Changelog: ToolDefinition = {
  name: "root-get-api-v3-changelog",
  description: ``,
  tool: async (client, ctx) => {
    const [result, apiCall] = await rootGetApiV3Changelog(
      client,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
